<template>
  <v-tooltip top v-if="(containsFornecedor || showNaoHomologado)
  && hasAnyFornecedoresProdutosHomologado">
    <template v-slot:activator="{ on }">
      <v-icon :class="iconClass"
              :small="small"
              :size="iconSize"
              :color="color"
              v-on="on">
        {{ icon }}
      </v-icon>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>
<script>
import { isEmpty } from 'lodash';
import { isFornecedorHomologado } from '@/utils/fornecedor-produto-utils';

export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    idFornecedor: {
      type: [String, Number],
      default: null,
    },
    produto: {
      type: Object,
      default: null,
    },
    iconClass: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: '20',
    },
    showNaoHomologado: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasAnyFornecedoresProdutosHomologado() {
      if (!isEmpty(this.produto.fornecedoresProduto)) {
        return this.produto.fornecedoresProduto.some(fp => fp.homologado);
      }
      return false;
    },
    containsFornecedor() {
      if (isEmpty(this.produto.fornecedoresProduto)) {
        return false;
      }
      return isFornecedorHomologado(this.produto.fornecedoresProduto, this.idFornecedor);
    },
    icon() {
      return this.containsFornecedor ? 'mdi-shield-check' : 'mdi-shield-alert';
    },
    color() {
      return this.containsFornecedor ? 'primary' : 'warning';
    },
    tooltip() {
      return this.containsFornecedor ? 'Fornecedor homologado ao produto' : 'Fornecedor não homologado ao produto';
    },
  },
};
</script>
